// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*DESKTOP*/
@media screen and (min-width:1024px) {
    .Form_btn__jvRmv {
        display: flex;
        justify-content: flex-end;
        margin-top: 5%;
    }
}

/*TABLET*/
@media screen and (min-width:767px) and (max-width:1024px) {
    .Form_btn__jvRmv {
        display: flex;
        place-content: center;
        margin-top: 5%;
    }
}

/*MOBILE*/
@media screen and (max-width:767px) {
    .Form_btn__jvRmv {
        display: flex;
        place-content: center;
        margin-top: 5%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/form/Form.module.css"],"names":[],"mappings":"AAAA,UAAU;AACV;IACI;QACI,aAAa;QACb,yBAAyB;QACzB,cAAc;IAClB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,cAAc;IAClB;AACJ;;AAEA,SAAS;AACT;IACI;QACI,aAAa;QACb,qBAAqB;QACrB,cAAc;IAClB;AACJ","sourcesContent":["/*DESKTOP*/\n@media screen and (min-width:1024px) {\n    .btn {\n        display: flex;\n        justify-content: flex-end;\n        margin-top: 5%;\n    }\n}\n\n/*TABLET*/\n@media screen and (min-width:767px) and (max-width:1024px) {\n    .btn {\n        display: flex;\n        place-content: center;\n        margin-top: 5%;\n    }\n}\n\n/*MOBILE*/\n@media screen and (max-width:767px) {\n    .btn {\n        display: flex;\n        place-content: center;\n        margin-top: 5%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn": `Form_btn__jvRmv`
};
export default ___CSS_LOADER_EXPORT___;
